"use strict";
'use es6';
/* eslint react/no-multi-comp: [1, {"ignoreStateless": true}] */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouter = require("react-router");

var _SettingsApplication = _interopRequireDefault(require("./containers/SettingsApplication"));

// Only import and use "containers" for your route handlers
var getFirstVisibleModulePath = function getFirstVisibleModulePath(module, _ref) {
  var scopes = _ref.scopes,
      gates = _ref.gates;

  if (module.modules) {
    var foundModule = module.modules.find(function (nestedModule) {
      return nestedModule.shouldModuleRender({
        scopes: scopes,
        gates: gates
      });
    });

    if (foundModule && foundModule.modules) {
      return foundModule.route + "/" + getFirstVisibleModulePath(foundModule, {
        scopes: scopes,
        gates: gates
      });
    } else if (foundModule) {
      return foundModule.route;
    }

    return null;
  }

  return module.route;
};

var generateNestedRouteFromModule = function generateNestedRouteFromModule(module, _ref2) {
  var scopes = _ref2.scopes,
      gates = _ref2.gates;

  if (module.shouldModuleRender({
    scopes: scopes,
    gates: gates
  })) {
    if (module.modules) {
      return _react.default.createElement(_reactRouter.Route, {
        path: module.route,
        key: module.route
      }, _react.default.createElement(_reactRouter.IndexRedirect, {
        to: getFirstVisibleModulePath(module, {
          scopes: scopes,
          gates: gates
        })
      }), module.modules.map(function (nested) {
        return generateNestedRouteFromModule(nested, {
          scopes: scopes,
          gates: gates
        });
      }));
    }

    if (module.routes.key) {
      return module.routes;
    }

    return _react.default.cloneElement(module.routes, {
      key: module.route
    });
  }

  return null;
};

var createRoutes = function createRoutes(_ref3) {
  var rootModule = _ref3.rootModule,
      scopes = _ref3.scopes,
      gates = _ref3.gates;
  return _react.default.createElement(_reactRouter.Route, {
    path: "/",
    component: _SettingsApplication.default
  }, _react.default.createElement(_reactRouter.IndexRedirect, {
    to: getFirstVisibleModulePath(rootModule, {
      scopes: scopes,
      gates: gates
    })
  }), rootModule.modules.map(function (nested) {
    return generateNestedRouteFromModule(nested, {
      scopes: scopes,
      gates: gates
    });
  }), _react.default.createElement(_reactRouter.Redirect, {
    from: "*",
    to: "/"
  }));
};

createRoutes.propTypes = {
  rootModule: _react.PropTypes.object,
  scopes: _react.PropTypes.array,
  gates: _react.PropTypes.array
};
var _default = createRoutes;
exports.default = _default;
module.exports = exports.default;